import { DefineColumn } from 'components/oldComponents/DataTable/types';

export const defineColumns: DefineColumn[] = [
  {
    id: 'name',
    hasSearch: true,
    label: 'Escola',
    numeric: false,
    renderComponent: 'customTextLink',
  },
  {
    id: 'brand',
    numeric: false,
    label: 'Marcas',
    maxWidth: 300,
  },
];
